import Vue from 'vue';
import lottie from 'lottie-web';

import ObsessedWith from '../animations/obsessed-with';
import ObsessedWithFame from '../animations/obsessed-with-fame';
import gsap from 'gsap/all';
import { CustomEase } from '../gsap-bonus/CustomEase';
import Cookies from 'js-cookie';

gsap.registerPlugin(CustomEase);

Vue.component('intro-animation-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            eventListenerActive: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        if (!this.$root.showIntroAnimation) {
            return;
        }

        const animationShown = Cookies.get('animationShown');

        if (animationShown === '1') {
            this.$root.showIntroAnimation = false;
            return;
        } else {
            Cookies.set('animationShown', '1', { expires: 1 });
        }

        const urlParams = new URLSearchParams(window.location.search);
        const showIntroParam = urlParams.get('showIntro');
        if (showIntroParam) {
            this.$root.showIntroAnimation = false;
            return;
        }

        Vue.nextTick(() => {
            this.initIntroAnimation();
            this.initLotties();
        });

        EventBus.$on('play-intro-animation', () => {
            gsap.set('.scroll-navigation__visuals', { x: '10vw' });

            Vue.nextTick(() => {
                this.introAnimationTl.play();
            });
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        initIntroAnimation() {
            this.introAnimationTl = gsap.timeline({
                paused: true,
                onComplete: () => {
                    this.$root.showIntroAnimation = false;
                },
            });

            CustomEase.create('overlayEase', '1, 0, 0.667, 1');
            CustomEase.create('maskEase', '0.56, 0, 0, 1');
            CustomEase.create('imageEase', '0.56, 0, 0.25, 1');
            CustomEase.create('generalEase', '0.45, 0, 0.33, 1');
            CustomEase.create('expoEase', '0.82, 0, 0.36, 1');

            // Show and hide obsessed with screen
            this.introAnimationTl.to(
                '.intro-animation__logo',
                { duration: 1, scale: 1, ease: 'generalEase' },
                0
            );
            this.introAnimationTl.to(
                '.intro-animation__container--logo',
                { duration: 0.8, y: '-100%', ease: 'generalEase' },
                1.5
            );
            this.introAnimationTl.to(
                [
                    '.intro-animation__container--header',
                    '.intro-animation__container--obsessed-with',
                ],
                {
                    duration: 0.8,
                    y: '0%',
                    ease: 'generalEase',
                    onComplete: () => {
                        this.obsessedWithAnimation.play();
                    },
                },
                1.4
            );
            this.introAnimationTl.to(
                '.intro-animation__header-logo',
                { duration: 1.3, y: 0, ease: 'generalEase' },
                1.4
            );
            this.introAnimationTl.to(
                ['.intro-animation__skip-text', '.intro-animation__skip-icon'],
                {
                    duration: 1,
                    stagger: 0.2,
                    autoAlpha: 1,
                    ease: 'generalEase',
                    onStart: () => {
                        gsap.set(
                            [
                                '.intro-animation__container--background',
                                '.intro-animation__slide--1',
                                '.intro-animation__slide--2',
                                '.intro-animation__slide--3',
                                '.intro-animation__slide--4',
                            ],
                            {
                                clip: `rect(0px, ${window.innerWidth}px, ${window.innerHeight}px, 0px)`,
                            }
                        );
                    },
                },
                1.9
            );

            // Remove obsessed with screen and slide through images
            this.introAnimationTl.to(
                '.intro-animation__container--background',
                {
                    duration: 1,
                    clip: `rect(0px, ${window.innerWidth}px, 0px, 0px)`,
                    ease: 'generalEase',
                },
                3
            );

            if (this.$parent.isMobile) {
                this.introAnimationTl.to(
                    '.intro-animation__header-logo path',
                    { duration: 0.2, fill: '#fff', ease: 'generalEase' },
                    3.6
                );
            } else {
                this.introAnimationTl.to(
                    '.intro-animation__header-logo path',
                    { duration: 0.2, fill: '#fff', ease: 'generalEase' },
                    3.2
                );
            }
            this.introAnimationTl.to(
                '.intro-animation__skip-icon',
                { duration: 0.2, stroke: '#fff', ease: 'generalEase' },
                3.2
            );
            this.introAnimationTl.to(
                '.intro-animation__skip',
                { duration: 0.2, color: '#fff', ease: 'generalEase' },
                3.2
            );
            this.introAnimationTl.to(
                '.intro-animation__slide--1 .intro-animation__slide-image',
                { duration: 2, scale: 1 },
                3
            );
            this.introAnimationTl.to(
                '.intro-animation__slide--1',
                {
                    duration: 1,
                    clip: `rect(0px, ${window.innerWidth}px, 0px, 0px)`,
                    ease: 'generalEase',
                },
                4
            );
            this.introAnimationTl.to(
                '.intro-animation__slide--2 .intro-animation__slide-image',
                { duration: 2, scale: 1 },
                4
            );
            this.introAnimationTl.to(
                '.intro-animation__slide--2',
                {
                    duration: 1,
                    clip: `rect(0px, ${window.innerWidth}px, 0px, 0px)`,
                    ease: 'generalEase',
                },
                5
            );
            this.introAnimationTl.to(
                '.intro-animation__slide--3 .intro-animation__slide-image',
                { duration: 2, scale: 1 },
                5
            );
            this.introAnimationTl.to(
                '.intro-animation__slide--3',
                {
                    duration: 1,
                    clip: `rect(0px, ${window.innerWidth}px, 0px, 0px)`,
                    ease: 'generalEase',
                },
                6
            );
            this.introAnimationTl.to(
                '.intro-animation__slide--4 .intro-animation__slide-image',
                { duration: 2, scale: 1 },
                6
            );
            this.introAnimationTl.to(
                '.intro-animation__slide--4',
                {
                    duration: 1,
                    clip: `rect(0px, ${window.innerWidth}px, 0px, 0px)`,
                    ease: 'generalEase',
                    onStart: () => {
                        gsap.set('.intro-animation', {
                            clip: `rect(0px, ${window.innerWidth}px, ${window.innerHeight}px, 0px)`,
                        });
                        this.obsessedWithFameAnimation.play();
                    },
                },
                7
            );

            // Hide intro animation and show scroll navigation
            this.introAnimationTl.to(
                '.intro-animation__overlay',
                { duration: 1.45, scaleX: 1, ease: 'overlayEase' },
                8.8
            );
            this.introAnimationTl.to(
                '.intro-animation',
                {
                    duration: 2,
                    clip: `rect(0px, 0px, ${window.innerHeight}px, 0px)`,
                    ease: 'maskEase',
                },
                9.3
            );
            this.introAnimationTl.to(
                '.scroll-navigation__visuals',
                { duration: 1.43, x: '0vw', ease: 'imageEase' },
                9.3
            );
        },

        initLotties() {
            const obsessedWithAnimationContainer = this.$el.querySelector(
                '.intro-animation__obsessed-with'
            );

            this.obsessedWithAnimation = lottie.loadAnimation({
                container: obsessedWithAnimationContainer,
                renderer: 'svg',
                loop: false,
                autoplay: false,
                rendererSettings: {
                    preserveAspectRatio: 'xMidYMid slice',
                },
                animationData: ObsessedWith,
            });

            const obsessedWithFameAnimationContainer = this.$el.querySelector(
                '.intro-animation__obsessed-with-fame'
            );

            this.obsessedWithFameAnimation = lottie.loadAnimation({
                container: obsessedWithFameAnimationContainer,
                renderer: 'svg',
                loop: false,
                autoplay: false,
                rendererSettings: {
                    preserveAspectRatio: 'xMidYMid slice',
                },
                animationData: ObsessedWithFame,
            });
        },

        skipIntro() {
            this.introAnimationTl.pause();

            gsap.set('.intro-animation', {
                clip: `rect(0px, ${window.innerWidth}px, ${window.innerHeight}px, 0px)`,
            });

            this.skipIntroAnimationTl = gsap.timeline({
                onComplete: () => {
                    this.$root.showIntroAnimation = false;
                },
            });

            this.skipIntroAnimationTl.to(
                '.intro-animation__overlay',
                { duration: 1.45, scaleX: 1, ease: 'overlayEase' },
                0
            );
            this.skipIntroAnimationTl.to(
                '.intro-animation',
                {
                    duration: 2,
                    clip: `rect(0px, 0px, ${window.innerHeight}px, 0px)`,
                    ease: 'maskEase',
                },
                0.5
            );
            this.skipIntroAnimationTl.to(
                '.scroll-navigation__visuals',
                { duration: 1.43, x: '0vw', ease: 'imageEase' },
                0.5
            );
        },
    },
});
